module.exports = __webpack_public_path__ + "static/media/34.886a5db5.jpg";